<script lang="ts">
    import ZentitySelect from '../../_common/z/zentity-select.svelte'
    import { get_current_component, onMount } from 'svelte/internal'
    import { ChannelsRepository } from '../../../modules/brokerApi/channels/channels.repository'
    import { ChannelsService } from '../../../modules/brokerApi/channels/channels.service'
    import { Channel, ChannelCredentials } from '../../../modules/brokerApi/channels/channel'
    import type { ChannelCreateDto } from '../../../modules/brokerApi/channels/channels-create.dto'
    import type { ChannelUpdateDto } from '../../../modules/brokerApi/channels/channels-update.dto'
    import { ChannelType, ChannelTypeFriendly, ThirdPartyChannel } from '../../../modules/brokerApi/channels/channels.enum'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Fa from 'svelte-fa'
    import { faInfoCircle, faCommentAlt, faPlug, faQrcode, faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import { User } from '../../../modules/usersApi/users/user'
    import { GridBadge, GridBadgeClassEnum, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Content from '../../_common/content.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import ZContainerCol from '../../_common/z/z-container-col.svelte'
    import ZinputTitle from '../../_common/z/zinput-title.svelte'
    import type { EvoGetConnectionDto } from '../../../modules/brokerApi/channels/dto/evo-get-connection.dto'
    import Popover from '../../_common/popover.svelte'
    import ProvidersWabaConnect from './providers-waba-connect.svelte'
    import { faPaperPlane } from '@fortawesome/free-regular-svg-icons'
    import type { WabaMetadataStatus } from '../../../modules/brokerApi/channels/dto/waba-metadata-status.dto'
    import ProvidersWabaStatus from './providers-waba-status.svelte'
    import ProvidersGmailConnect from './providers-gmail-connect.svelte'

    const rep = new ChannelsRepository()
    const service = new ChannelsService(rep)

    // WhatsApp por provedor não-oficial: nenhum deles pode aparecer em contas com compliance
    const unofficialWhatsApp = [
        ChannelType.wa_evo2_user,
        ChannelType.wa_evo2_zandu,
        ChannelType.wa_uazapi_user,
        ChannelType.wa_uazapi_zandu,
    ]
    // a flag 'evo' controla o rollout da Evolution; a flag 'uazapi' libera o servidor uazapi da Zandu.
    // A uazapi de terceiros não depende de flag: o cliente usa o servidor dele.
    const evolutionOnly = [ChannelType.wa_evo2_user, ChannelType.wa_evo2_zandu]

    let channelTypes = Object.values(ChannelType)
    if (window.featureFlags.includes('compliance')) {
        channelTypes = channelTypes.filter((el) => el !== ChannelType.wa_user && !unofficialWhatsApp.includes(el))
    } else {
        if (!window.featureFlags.includes('evo')) {
            channelTypes = channelTypes.filter((el) => !evolutionOnly.includes(el))
        }
        if (!window.featureFlags.includes('uazapi')) {
            channelTypes = channelTypes.filter((el) => el !== ChannelType.wa_uazapi_zandu)
        }
    }
    channelTypes = channelTypes.filter((el) => el !== ChannelType.call_user)
    channelTypes = channelTypes.filter((el) => el !== ChannelType.sms_smsempresa)

    let user: User
    let disabled = false

    const me = get_current_component()
    let show = false
    let step = 1
    let entities: Channel[] = []
    let entity: Channel = new Channel()
    let showWAInfo: boolean = false
    let showApkInfo: boolean = false
    let days: { label: string; value: number }[] = []
    days.push({ label: 'dom', value: 0 })
    days.push({ label: 'seg', value: 1 })
    days.push({ label: 'ter', value: 2 })
    days.push({ label: 'qua', value: 3 })
    days.push({ label: 'qui', value: 4 })
    days.push({ label: 'sex', value: 5 })
    days.push({ label: 'sab', value: 6 })

    // opção vazia explícita: sem ela o select fica sem seleção visível enquanto o tipo está vazio
    const channelTypeOptions = [{ value: '', label: '' }, ...channelTypes.map((type) => ({ value: type, label: ChannelTypeFriendly[type] }))]
    const retriesOptions = [0, 1, 2, 3].map((value) => ({ value, label: String(value) }))
    const transportOptions = ['udp+tcp', 'udp', 'tcp', 'tls'].map((value) => ({ value, label: value }))

    onMount(async () => {
        await loadAppData()
        await loadEntities()
    })

    let appData: { x64: { link }; x86: { link } } = null

    async function loadAppData() {
        appData = await window.api.brokers.channels.getAppData()
        if (!appData?.x64?.link) {
            appData['x64']['link'] = 'https://appzanducombr.s3.sa-east-1.amazonaws.com/ZanduWindows_Setup_38_x64.exe'
        }
        if (!appData?.x86?.link) {
            appData['x86']['link'] = 'https://appzanducombr.s3.sa-east-1.amazonaws.com/ZanduWindows_Setup_38_x86.exe'
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await service.getAll()
            console.log('channels', entities)
            showWAInfo = entities.find((el) => el.type === ChannelType.wa_user) ? true : false
            showApkInfo = entities.find((el) => el.type === ChannelType.call_user) ? true : false
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function editEntity(id: string) {
        try {
            show = true
            entity = new Channel()
            entity = await service.getOne(id)
            // canal sem janela configurada abre o dia inteiro, como um canal novo
            sendWindowFrom = minuteToDate(entity.sendWindowFrom ?? 0)
            sendWindowTo = minuteToDate(entity.sendWindowTo ?? 23 * 60 + 59)
            if (!entity.sendWindowDays || entity.sendWindowDays.length === 0) {
                entity.sendWindowDays = entity.sendWindowDays = [0, 1, 2, 3, 4, 5, 6]
            }
            user = new User()
            user.userId = entity.userId
            console.log('channel', entity)
            step = 2
            disabled = true
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new Channel()
        sendWindowFrom = minuteToDate(0)
        sendWindowTo = minuteToDate(23 * 60 + 59)
        entity.sendWindowDays = [1, 2, 3, 4, 5, 6]
        entity.sendLimit = 50
        disabled = false
        user = new User()
        step = 2
    }

    async function saveEntity() {
        if (entity.channelId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    function validateDto(dto) {
        // sendWindowFrom/To são minutos desde a meia-noite, não datas
        if (!Number.isFinite(dto.sendWindowFrom) || !Number.isFinite(dto.sendWindowTo)) {
            window.error('Informe o "horário permitido para envio" inicial e final.')
            return false
        }
        if (dto.sendWindowTo < dto.sendWindowFrom) {
            window.error('O "horário permitido para envio" inicial deve ser menor que o final.')
            return false
        }

        return true
    }

    async function createEntity() {
        try {
            show = true
            const dto: ChannelCreateDto = {
                label: entity.label,
                type: entity.type,
                token: entity.token,
                sendLimit: entity.sendLimit,
                sendWindowFrom: dateToMinute(sendWindowFrom),
                sendWindowTo: dateToMinute(sendWindowTo),
                sendWindowDays: entity.sendWindowDays,
                voipDomain: entity.voipDomain,
                voipPassword: entity.voipPassword,
                voipUsername: entity.voipUsername,
                voipTransport: entity.voipTransport,
                userId: user?.userId || null,
                retriesAllowed: entity.retriesAllowed,
                externalId: entity.externalId,
                externalName: entity.externalName,
                externalUrl: entity.externalUrl,
            }
            if (!validateDto(dto)) return
            entity = await service.create(dto)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    // o Zinput type="time" trabalha com Date (entra Date, sai Date) — nunca com string 'HH:mm'
    let sendWindowFrom: Date = null
    let sendWindowTo: Date = null

    function minuteToDate(minute: number): Date {
        if (!Number.isFinite(minute)) return null
        const date = new Date()
        date.setHours(0, minute, 0, 0)
        return date
    }

    function dateToMinute(date): number {
        const value = date instanceof Date ? date : new Date(date)
        if (isNaN(value.getTime())) return null
        return value.getHours() * 60 + value.getMinutes()
    }

    async function updateEntity() {
        try {
            show = true
            const dto: ChannelUpdateDto = {
                label: entity.label,
                token: entity.token,
                sendLimit: entity.sendLimit,
                sendWindowFrom: dateToMinute(sendWindowFrom),
                sendWindowTo: dateToMinute(sendWindowTo),
                sendWindowDays: entity.sendWindowDays || [0, 1, 2, 3, 4, 5, 6],
                voipDomain: entity.voipDomain,
                voipPassword: entity.voipPassword,
                voipUsername: entity.voipUsername,
                voipTransport: entity.voipTransport,
                userId: user?.userId || null,
                retriesAllowed: entity.retriesAllowed,
                externalId: entity.externalId,
                externalName: entity.externalName,
                externalUrl: entity.externalUrl,
            }
            if (!validateDto(dto)) return
            await service.update(entity.channelId, dto)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await service.remove(entity.channelId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let serviceType = null
    let serviceToken = null
    async function goClearOutbox(_serviceType: String, _serviceToken: string) {
        serviceType = _serviceType
        serviceToken = _serviceToken
        step = 3
    }

    async function clearOutbox() {
        show = true
        await window.api.brokers.recipient.clearOutbox(serviceType.split('_')[0], serviceToken)
        setTimeout(() => {
            show = false

            window.alert(
                'Comando enviado!\nAtenção: a limpeza da caixa de saída pode levar algum tempo. É normal que você continue vendo mensagens na caixa de saída referente a este provedor durante este período.',
            )
            step = 1
        }, 4000)
    }

    function showEntities() {
        step = 1
    }

    function friendlyDate(date) {
        if (!date) return '-'
        let str = dayjs(date).format('DD/MM/YYYY HH:mm:ss')
        let diff = -dayjs(date).diff(new Date(), 's')
        if (diff <= 300) {
            return str + ' (há ' + diff + ' segundos)'
        }
        diff = -dayjs(date).diff(new Date(), 'h')
        if (diff <= 48) {
            return str + ' (há ' + diff + ' horas)'
        }
        diff = -dayjs(date).diff(new Date(), 'd')
        if (diff <= 31) {
            return str + ' (há ' + diff + ' dias)'
        }
        return str
    }

    function evaluateError(error) {
        window.error(error)
    }

    let bitness = 0
    let highConfidenceBitness = false
    async function isWinX64() {
        try {
            // @ts-ignore
            bitness = (await navigator.userAgentData?.getHighEntropyValues(['bitness']))?.bitness
            //if (bitness) highConfidenceBitness = true
            console.log('bitness', bitness)
        } catch (error) {
            if (navigator.userAgent.indexOf('WOW64') != -1 || navigator.userAgent.indexOf('Win64') != -1) {
                bitness = 64
            } else {
                bitness = 32
            }
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.fontSize = '13px'
        grid.title = 'Provedores de Comunicação'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Nome' }))
        grid.cols.push(new GridCol({ content: 'Tipo', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Versão' }))
        grid.cols.push(new GridCol({ content: 'Abertura', type: GridColTypeEnum.datetime_friendly }))
        grid.cols.push(new GridCol({ content: 'Ping', type: GridColTypeEnum.datetime_friendly }))
        grid.cols.push(new GridCol({ content: 'ID do canal' }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let btns = []
            let btnClear = new GridButton({
                callback: () => goClearOutbox(item.type, item.token),
                icon: faTrashAlt,
                label: 'Limpar Saída',
            })
            let btnEdit = new GridButton({
                callback: () => editEntity(item.channelId),
                icon: faEdit,
                label: 'Editar',
            })
            let btnEvoConnect = new GridButton({
                callback: () => evoConnect(item.channelId),
                icon: faQrcode,
                label: 'Conectar',
            })

            let btnEvoDisconnect = new GridButton({
                callback: () => evoDisconnect(item.channelId),
                icon: faPlug,
                label: 'Desconectar',
            })

            if (item.status >= 100) {
                let btnWabaSendMessage = new GridButton({
                    callback: () => window.message({ channelId: item.channelId }),
                    icon: faPaperPlane,
                    label: 'Enviar',
                    disabled: item.status <= 40 ? true : false,
                })
                if (window.featureFlags.includes('compliance')) {
                    btns.push(btnWabaSendMessage)
                }
            }

            if (item.type === ChannelType.wa_evo2_user || item.type === ChannelType.wa_evo2_zandu) {
                if (item.status === 40) {
                    btns.push(btnEvoConnect)
                } else {
                    btns.push(btnEvoDisconnect)
                }
            }

            // waba
            if (item.type === ChannelType.waba_user) {
                let btnWABAStatus = new GridButton({
                    callback: () => wabaStatus(item.metadata, item.credentials),
                    icon: faInfoCircle,
                    label: 'Status',
                })

                let btnWABAConnect = new GridButton({
                    callback: () => wabaConnect(item.channelId),
                    icon: faPlug,
                    label: 'Conectar',
                })

                let btnWABADisconnect = new GridButton({
                    callback: () => wabaDisconnect(item.channelId),
                    icon: faPlug,
                    label: 'Desconectar',
                })

                if (item.status <= 40 && item.status != 10) {
                    btns.push(btnWABAConnect)
                } else {
                    btns.push(btnWABAStatus)
                    btns.push(btnWABADisconnect)
                }
            }

            // uazapi
            if (item.type === ChannelType.wa_uazapi_user || item.type === ChannelType.wa_uazapi_zandu) {
                let btnUazapiConnect = new GridButton({
                    callback: () => uazapiConnect(item.channelId),
                    icon: faQrcode,
                    label: 'Conectar',
                })
                let btnUazapiDisconnect = new GridButton({
                    callback: () => uazapiDisconnect(item.channelId),
                    icon: faPlug,
                    label: 'Desconectar',
                })
                if (item.status >= 100) {
                    btns.push(btnUazapiDisconnect)
                } else {
                    btns.push(btnUazapiConnect)
                }
            }

            // gmail
            if (item.type === ChannelType.email_gmail) {
                let btnGmailConnect = new GridButton({
                    callback: () => gmailConnect(item.channelId),
                    icon: faPlug,
                    label: 'Conectar',
                })

                let btnGmailAccount = new GridButton({
                    callback: () => gmailConnect(item.channelId),
                    icon: faInfoCircle,
                    label: 'Conta',
                })

                let btnGmailDisconnect = new GridButton({
                    callback: () => gmailDisconnect(item.channelId),
                    icon: faPlug,
                    label: 'Desconectar',
                })

                if (item.status <= 40 && item.status != 10) {
                    btns.push(btnGmailConnect)
                } else {
                    btns.push(btnGmailAccount)
                    btns.push(btnGmailDisconnect)
                }
            }

            if (item.token && item.type === ChannelType.wa_user) {
                btns.push(btnClear)
                btns.push(btnEdit)
            } else {
                btns.push(btnEdit)
            }

            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: new GridBadge({ label: getType(item.type), class: GridBadgeClassEnum.badge_default }) })
            line.slots.push({ content: new GridBadge({ label: getStatusLabel(item.status), class: getStatusClass(item.status) }) })
            line.slots.push({ content: item.metadata?.version || '-' })
            line.slots.push({ content: item.startAt })
            line.slots.push({ content: item.syncAt })
            line.slots.push({ content: item.channelId })
            line.slots.push({ content: btns })
            grid.lines.push(line)
        }
    }

    // QR Code compartilhado pelos provedores que pareiam por leitura (evolution e uazapi)
    let qrCode = null
    async function evoConnect(channelId: string) {
        try {
            show = true
            const result: EvoGetConnectionDto = await window.api.brokers.channels.evoGetConnection(channelId)
            console.log('evo-connect', result)
            if (!result.success) {
                window.error('Ocorreu um erro ao tentar conectar:\n' + result.message)
                return
            }
            qrCode = result.base64
        } catch (error) {
            qrCode = null
        } finally {
            show = false
        }
    }

    async function uazapiConnect(channelId: string) {
        try {
            show = true
            const result: EvoGetConnectionDto = await window.api.brokers.channels.uazapiGetConnection(channelId)
            console.log('uazapi-connect', result)
            if (!result.success) {
                window.error('Ocorreu um erro ao tentar conectar:\n' + result.message)
                return
            }
            qrCode = result.base64
        } catch (error) {
            window.error(error)
            qrCode = null
        } finally {
            show = false
        }
    }

    async function uazapiDisconnect(channelId: string) {
        if (!confirm('Deseja mesmo desconectar este canal?')) {
            return
        }
        try {
            show = true
            await window.api.brokers.channels.uazapiLogout(channelId)
        } catch (error) {
            window.error(error)
        } finally {
            await loadEntities()
            show = false
        }
    }

    let wabaMetadataStatus: WabaMetadataStatus = null
    let wabaCredentials: ChannelCredentials = null
    function wabaStatus(metadata: any, credentials) {
        console.log('metadata', metadata)
        if (metadata?.['status']) {
            wabaMetadataStatus = metadata['status']
            wabaCredentials = credentials
        }
    }

    let wabaConChannelId = null
    function wabaConnect(channelId: string) {
        wabaConChannelId = channelId
    }

    async function wabaOnConnect() {
        wabaConChannelId = null
        loadEntities()
    }

    let wabaTemChannelId = null
    function wabaTemplates(channelId: string) {
        wabaTemChannelId = channelId
    }

    async function wabaDisconnect(channelId: string) {
        if (!confirm('Deseja mesmo desconectar este canal?')) {
            return
        }
        try {
            show = true
            await window.api.brokers.channels.wabaLogout(channelId)
            window.alert(
                `O Zandu foi desconectado de seu WhatsApp.\n\nATENÇÃO: mensagens na fila ainda poderão ser enviadas.\nPara garantir que isso não ocorra desconecte o WhatsApp através de seu celular (acessando Dispositivos Conectados).`,
            )
        } catch (error) {
        } finally {
            loadEntities()
            show = false
        }
    }

    let gmailConChannelId = null
    function gmailConnect(channelId: string) {
        gmailConChannelId = channelId
    }

    async function gmailOnConnect() {
        gmailConChannelId = null
        await loadEntities()
    }

    async function gmailDisconnect(channelId: string) {
        if (!confirm('Deseja mesmo desconectar esta conta Google?')) {
            return
        }
        try {
            show = true
            await window.api.brokers.channels.gmailLogout(channelId)
            window.alert(
                'A conta Google foi desconectada.\n\nATENÇÃO: mensagens já na fila deste provedor não serão enviadas.',
            )
        } catch (error) {
            window.error(error)
        } finally {
            await loadEntities()
            show = false
        }
    }

    async function evoDisconnect(channelId: string) {
        try {
            show = true
            const result: EvoGetConnectionDto = await window.api.brokers.channels.evoLogout(channelId)
            console.log('evo-disconnect', result)
            if (!result.success) {
                // window.error('Ocorreu um erro ao tentar conectar:\n' + result.message)
                // return
            }
        } catch (error) {
        } finally {
            await loadEntities()
            show = false
        }
    }

    function getStatusClass(status: number) {
        if (status === 40) return GridBadgeClassEnum.badge_danger
        if (status === 80) return GridBadgeClassEnum.badge_danger
        if (status === 10) return GridBadgeClassEnum.badge_danger
        if (status === 100) return GridBadgeClassEnum.badge_default
        if (status === 105) return GridBadgeClassEnum.badge_success
        return GridBadgeClassEnum.badge_default
    }

    function getStatusLabel(status: number) {
        if (status === 40) return 'desconectado'
        if (status === 10) return 'suspenso'
        if (status === 80) return 'offline'
        if (status === 100) return 'ativo'
        if (status === 105) return 'online'
        return status.toString()
    }

    function getType(type: ChannelType) {
        if (type === ChannelType.sms_smsempresa) return 'sms'
        if (type === ChannelType.voip_user) return 'voip'
        if (type === ChannelType.wa_user) return 'wa local'
        if (type === ChannelType.wa_evo2_user) return 'wa evo'
        if (type === ChannelType.wa_evo2_zandu) return 'wa nuvem'
        if (type === ChannelType.wa_uazapi_user) return 'wa uazapi'
        if (type === ChannelType.wa_uazapi_zandu) return 'wa nuvem (uazapi)'
        if (type === ChannelType.email_gmail) return 'e-mail gmail'
        if (type === ChannelType.email_sendgrid) return 'e-mail sendgrid'
        if (type === ChannelType.call_user) return 'celular'
        return type
    }

    async function qrCodeOnClose() {
        await loadEntities()
        qrCode = null
    }

    isWinX64()
</script>

{#if qrCode}
    <Popover on:close={qrCodeOnClose} width="590px" height="100px">
        <div class="config-box m-4 d-flex flex-column align-items-center">
            <p class="subtitle mb-5">Escaneie o QR Code com o aplicativo do WhatsApp</p>
            <img src={qrCode} alt="QR Code para conectar o WhatsApp" />
            <div class="mt-5">Quando seu aparelho se conectar você poderá fechar esta janela.</div>
        </div>
    </Popover>
{/if}

{#if wabaConChannelId}
    <Popover width="690px" height="100px" on:close={() => (wabaConChannelId = null)}>
        <ProvidersWabaConnect channelId={wabaConChannelId} on:connected={wabaOnConnect}></ProvidersWabaConnect>
    </Popover>
{/if}

{#if gmailConChannelId}
    <Popover width="690px" height="100px" on:close={() => (gmailConChannelId = null)}>
        <ProvidersGmailConnect channelId={gmailConChannelId} on:connected={gmailOnConnect}></ProvidersGmailConnect>
    </Popover>
{/if}

{#if wabaMetadataStatus}
    <Popover width="1090px" on:close={() => (wabaMetadataStatus = null)}>
        <ProvidersWabaStatus status={wabaMetadataStatus} credentials={wabaCredentials}></ProvidersWabaStatus>
    </Popover>
{/if}

<Content footer={true}>
    {#if step === 1}
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.marketing.providers.write}
                <Zbutton color="primary" icon={faPlusCircle} label="Novo" mobileHideLabel={true} on:click={newEntity} />
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
        {#if showWAInfo}
            <div class="alert alert-secondary mt-5 text-center">
                Você cadastrou o envio de WhatsApp através de seu número.<br />
                Para que seu WhatsApp faça o envio das mensagens você precisa instalar o aplicativo de envio do Zandu em seu computador e mantê-lo sempre aberto:<br
                />
                <a class="btn btn-primary mt-2" href="/resources/download-windows">Baixar Zandu Comunicação</a>
            </div>
        {/if}
        {#if showApkInfo}
            <div class="alert alert-secondary mt-3 text-center">
                Você cadastrou um canal de monitoramento para seu celular.<br />
                Para que o Zandu possa contabilizar as estatísticas de seu celular instale o aplicativo Android através do link abaixo:<br />
                <a class="btn btn-primary mt-2" target="_blank" href="https://appzanducombr.s3.sa-east-1.amazonaws.com/ZanduAndroid.apk"
                    >Baixar Zandu Sync - Android</a
                ><br /><br />
                Se preferir copie o link abaixo e envie par seu telefone:<br />
                <input type="text" class="form-control max-width-text" value="https://appzanducombr.s3.sa-east-1.amazonaws.com/ZanduAndroid.apk" />
            </div>
        {/if}
    {/if}
    {#if step === 2}
        <Zact>
            <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
            <div class="spacer" />
            {#if window.store.token.permissions.tools.providers.write}
                {#if entity.channelId}
                    <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeEntity} />
                {/if}
                <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={saveEntity} />
            {/if}
        </Zact>
        <Zframe class="h-space">
            <ZContainer gapRow="8px" gapCol="8px">
                <Zinput size={6} sizeM={12} label="Nome para a conexão" type="text" bind:value={entity.label} />
                <Zinput size={6} sizeM={12} label="Conexão com" type="select" options={channelTypeOptions} {disabled} bind:value={entity.type} />

                {#if entity.type && ThirdPartyChannel.includes(entity.type)}
                    <Zinput size={6} sizeM={12} label="Token fornecido pelo provedor" type="text" bind:value={entity.token} />
                {/if}
                {#if entity.type === ChannelType.wa_uazapi_user}
                    <Zinput
                        size={6}
                        sizeM={12}
                        label="Servidor uazapi"
                        type="text"
                        placeholder="https://seuservidor.uazapi.com"
                        bind:value={entity.externalUrl}
                    />
                    <Zinput size={6} sizeM={12} label="Admin token" type="text" {disabled} bind:value={entity.token} />
                {/if}
                {#if (entity.type === ChannelType.wa_uazapi_user || entity.type === ChannelType.wa_uazapi_zandu) && !entity.channelId}
                    <ZContainerCol size={12}>
                        <div class="alert alert-secondary mb-0">
                            A instância será criada automaticamente ao salvar. Depois use o botão <strong>Conectar</strong> na lista para ler o QR Code.
                        </div>
                    </ZContainerCol>
                {/if}
                {#if entity.type === ChannelType.email_gmail}
                    <ZContainerCol size={12}>
                        <div class="alert alert-secondary mb-0">
                            {#if entity.channelId}
                                Use o botão <strong>Conectar</strong> na lista de provedores para entrar com sua conta Google.
                            {:else}
                                Salve o provedor primeiro. Depois use o botão <strong>Conectar</strong> na lista para entrar com sua conta Google.
                            {/if}
                        </div>
                    </ZContainerCol>
                {/if}
                {#if entity.type === ChannelType.voip_user}
                    <Zinput size={3} sizeM={12} label="Domínio" type="text" bind:value={entity.voipDomain} />
                    <Zinput size={3} sizeM={12} label="Usuário" type="text" bind:value={entity.voipUsername} />
                    <Zinput size={3} sizeM={12} label="Senha" type="password" bind:value={entity.voipPassword} />
                    <Zinput size={3} sizeM={12} label="Transporte" type="select" options={transportOptions} bind:value={entity.voipTransport} />
                {/if}
                {#if entity.type === ChannelType.wa_evo2_user}
                    <Zinput size={3} sizeM={12} label="Domínio" type="text" bind:value={entity.externalUrl} />
                    <Zinput size={3} sizeM={12} label="Token" type="text" bind:value={entity.token} />
                    <Zinput size={3} sizeM={12} label="Nome da instância" type="text" disabled={true} bind:value={entity.externalName} />
                {/if}

                {#if entity.type !== ChannelType.call_user}
                    <Zinput size={3} sizeM={6} label="Horário permitido para envio" type="time" bind:value={sendWindowFrom} />
                    <Zinput size={3} sizeM={6} label="Até" type="time" bind:value={sendWindowTo} />
                {/if}
                <ZContainerCol size={6} sizeM={12}>
                    <ZentitySelect fonte="usuario" bind:value={user} label="Usuário vinculado" />
                </ZContainerCol>

                {#if entity.type === ChannelType.sms_smsempresa || entity.type === ChannelType.wa_user || entity.type === ChannelType.email_sendgrid}
                    <Zinput size={6} sizeM={12} label="Retentativas" type="select" options={retriesOptions} bind:value={entity.retriesAllowed} />
                    <ZContainerCol size={12}>
                        <div class="text-muted">
                            Você pode ativar uma retentativa caso a mensagem não seja entregue.<br />
                            As retentativas ocorrem a cada 30 minutos.
                        </div>
                    </ZContainerCol>
                {/if}

                {#if entity.type !== ChannelType.call_user}
                    <ZinputTitle title="Limites para envios de Marketing" />
                    <Zinput size={6} sizeM={12} label="Limite de envio diário (0=sem limite)" type="number" bind:value={entity.sendLimit} />
                    <Zinput
                        size={6}
                        sizeM={12}
                        label="Dias permitidos para envio"
                        type="inlineselect_2"
                        multi={true}
                        options={days}
                        bind:value={entity.sendWindowDays}
                    />
                    {#if entity.type === ChannelType.wa_user && entity.sendLimit > 100}
                        <ZContainerCol size={12}>
                            <div class="alert alert-warning text-center mb-0">
                                Atenção: Envio de mensagens em massa pode levar uma quantidade grande de destinatários a marcá-las como SPAM.<br />
                                Ao receber denúncias de SPAM o WhatsApp pode vir a banir seu número de forma temporária ou até definitiva.<br />
                                Evite enviar grandes quantidades de mensagens em um único dia.
                            </div>
                        </ZContainerCol>
                    {/if}
                {/if}
            </ZContainer>
        </Zframe>
    {/if}
    {#if step === 3}
        <Zact>
            <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={() => (step = 2)} />
            <div class="spacer" />
        </Zact>
        <Zframe title="Exclusão de Mensagens da Caixa de Saída" class="h-space">
            <p>Você está prestes a excluir suas mensagens da caixa de saída. Lembre-se:</p>
            <ul>
                <li>Esta ação não poderá ser desfeita.</li>
                <li>Todas as mensagens desse provedor de comunicação serão removidas.</li>
                <li>A exclusão leva alguns segundos. Pode ser que nesse período uma ou outra mensagem seja enviada antes que a exclusão termine.</li>
                <li>Enquanto a exclusão é processada pode ser que você veja algumas mensagens na caixa de saída por algum tempo.</li>
            </ul>
            <div class="text-center">
                <Zbutton color="red" icon={faTrashAlt} label="Limpar caixa de saída" disabled={show} on:click={clearOutbox} />
            </div>
        </Zframe>
    {/if}

    <LoadSpinner delay={0} {show} />
</Content>

<style>
    .max-width-text {
        text-align: center;
        max-width: 680px;
        margin: 0 auto;
    }
</style>
